import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
	AlarisDateFormatService,
	AlarisIconDirective,
	AlarisTooltipDirective,
	DateFormatPipe,
} from '@campaign-portal/components-library';
import { DatePipe, LowerCasePipe, NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CampaignStatus } from '@campaign-portal/namespace/entities/campaigns/specs';
import {
	CampaignNextRunDay,
	CampaignSchedulerUtilsService,
} from '../../../campaign-wizard/campaign-completed/campaign-scheduler/campaign-scheduler-utils.service';
import { CampaignEntity } from '@shared/types';

@Component({
	selector: 'app-campaign-details-dates',
	imports: [
		AlarisIconDirective,
		DateFormatPipe,
		DatePipe,
		TranslateModule,
		AlarisTooltipDirective,
		LowerCasePipe,
		NgTemplateOutlet,
	],
	templateUrl: './campaign-details-dates.component.html',
	styleUrl: './campaign-details-dates.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignDetailsDatesComponent {
	@Input({ required: true }) campaign!: CampaignEntity;
	@Input() isCampaignFromRecurrentHistory = false;

	protected readonly CampaignStatus = CampaignStatus;
	protected readonly CampaignNextRunDay = CampaignNextRunDay;

	constructor(
		public readonly schedulerUtils: CampaignSchedulerUtilsService,
		public readonly dateFormat: AlarisDateFormatService
	) {}
}
